module.exports = __webpack_public_path__ + "img/backgroundImage.107714c2.jpeg";